import { Component, OnInit } from '@angular/core';
import { InceptionService, TranslationService } from '@proximus/ng-common';

@Component({
  selector: 'mprd-public-wifi-pxsplus-no-simcard',
  templateUrl: './public-wifi-pxsplus-no-simcard.component.html',
  styleUrls: ['./public-wifi-pxsplus-no-simcard.component.css'],
})
export class PublicWifiPxsplusNoSimcardComponent implements OnInit {
  backUrlFromApp: string;

  constructor(
    private inceptionService: InceptionService,
    private translationService: TranslationService,
  ) {}

  ngOnInit() {
    if (window['MyProximusMobileApp']) {
      this.backUrlFromApp = this.translationService.getTranslatedValueFor(
        'common.myproximus.back.url',
      );
    }
    setTimeout(() => {
      this.inceptionService.init();
    });
  }

  goBack() {
    this.backUrlFromApp
      ? window.open(this.backUrlFromApp)
      : window.history.back();
  }
}
